import { render, staticRenderFns } from "./advStatistics.vue?vue&type=template&id=5dfc8266&"
import script from "./advStatistics.vue?vue&type=script&lang=js&"
export * from "./advStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports